<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="onSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">แก้ไขข้อมูลร้านค้า</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
              <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label">รหัสร้านค้า:</label>
                          <span class="form-control-plaintext">{{eShCustomerCode}}</span>
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ชื่อร้านค้า:</label>
                          <input :disabled="!canEdit"
                                 id="eShCustomerName"
                                 name="eShCustomerName"
                                 v-model="eShCustomerName"
                                 type="text"
                                 maxlength="256"
                                 class="form-control"
                                 placeholder="ชื่อร้านค้า" />
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ชื่อร้านค้า 2:</label>
                          <input :disabled="!canEdit"
                                 id="eShName2"
                                 name="eShName2"
                                 v-model="eShName2"
                                 type="text"
                                 maxlength="256"
                                 class="form-control"
                                 placeholder="ชื่อร้านค้า 2" />
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ประเภทร้านค้า:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShShopType'"
                                   :name="'eShShopType'"
                                   :select2-options="eShShopTypeOptions"
                                   v-model="eShShopType"
                                   ref="eShShopTypeSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ประเภทการล้างเครื่อง:  </label>
                          <select2 :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShShopPMType'"
                                   :name="'eShShopPMType'"
                                   :select2-options="eShShopPMTypeOptions"
                                   v-model="eShShopPMType"
                                   ref="eShShopPMTypeSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">สถานะประเภทร้านค้า:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShShopGroup'"
                                   :name="'eShShopGroup'"
                                   :select2-options="eShShopGroupOptions"
                                   v-model="eShShopGroup"
                                   ref="eShShopGroupSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ที่อยู่:</label>
                          <input :disabled="!canEdit"
                                 id="eShAddress"
                                 name="eShAddress"
                                 v-model="eShAddress"
                                 type="text"
                                 maxlength="256"
                                 class="form-control"
                                 placeholder="ที่อยู่" />
                      </div>
                  </div>

                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">จังหวัด:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShProvinceId'"
                                   :name="'eShProvinceId'"
                                   :select2-options="eShProvinceIdOptions"
                                   v-model="eShProvinceId"
                                   ref="eShProvinceIdSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">อำเภอ:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShAmphurId'"
                                   :name="'eShAmphurId'"
                                   :select2-options="eShAmphurIdOptions"
                                   v-model="eShAmphurId"
                                   ref="eShAmphurIdSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ตำบล:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShTumbolId'"
                                   :name="'eShTumbolId'"
                                   :select2-options="eShTumbolIdOptions"
                                   v-model="eShTumbolId"
                                   ref="eShTumbolIdSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label>ตัวแทนจำหน่ายย่อย:</label>
                          <div class="form-check">
                              <label class="form-check-label kt-checkbox">
                                  <input :disabled="!canEdit"
                                         id="eShSubAgent"
                                         name="eShSubAgent"
                                         v-model="eShSubAgent"
                                         type="checkbox"
                                         class="form-check-input" />
                                  <span></span>
                                  เปิดใช้งาน
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-12col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label">ชื่อ-สกุลผู้ติดต่อ:</label>
                          <input :disabled="!canEdit"
                                 id="eShContactFullName"
                                 name="eShContactFullName"
                                 v-model="eShContactFullName"
                                 type="text"
                                 maxlength="256"
                                 class="form-control"
                                 placeholder="ชื่อ-สกุลผู้ติดต่อ" />
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label">อีเมล:</label>
                          <input :disabled="!canEdit"
                                 id="eShEmail"
                                 name="eShEmail"
                                 v-model="eShEmail"
                                 type="text"
                                 maxlength="400"
                                 class="form-control"
                                 placeholder="อีเมล" />
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">เบอร์โทร:</label>
                          <input :disabled="!canEdit"
                                 id="eShTel"
                                 name="eShTel"
                                 v-model="eShTel"
                                 type="text"
                                 maxlength="256"
                                 class="form-control"
                                 placeholder="เบอร์โทร" />
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label-required">ผู้ดูแลร้านค้า:</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShAgentCode'"
                                   :name="'eShAgentCode'"
                                   :select2-options="eShAgentCodeOptions"
                                   v-model="eShAgentCode"
                                   ref="eShAgentCodeSelect2"></select2>
                          <span class="form-text"></span>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label">ชื่อเจ้าหน้าที่ดูแล (ตัวแทน):</label>
                          <input :disabled="!canEdit"
                                 id="eShContactAgentName"
                                 name="eShContactAgentName"
                                 v-model="eShContactAgentName"
                                 type="text"
                                 class="form-control" />
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div class="form-group">
                          <label class="label">นามสกุลเจ้าหน้าที่ดูแล (ตัวแทน):</label>
                          <input :disabled="!canEdit"
                                 id="eShContactAgentLName"
                                 name="eShContactAgentLName"
                                 v-model="eShContactAgentLName"
                                 type="text"
                                 class="form-control" />
                      </div>
                  </div>
                  <div class="col-xl-6" v-if="$root.canShow('super_admin')">
                      <div class="form-group">
                          <label class="label">เจ้าหน้าที่ดูแล (Boonrawd)</label>
                          <select2 :disabled="!canEdit"
                                   :class="'form-control m-select2'"
                                   :style="'width: 100%;'"
                                   :id="'eShEmp'"
                                   :name="'eShEmp'"
                                   :select2-options="eShEmpOptions"
                                   v-model="eShEmp"
                                   ref="eShEmpSelect2"></select2>
                      </div>
                  </div>
              </div>
              <!-- Begin: CR-PM-2026 Req 2 — ตั้งค่าระยะ Check-In/Check-Out -->
              <div class="row">
                <div class="col-xl-12">
                  <div class="form-group">
                    <label class="label-required">ตั้งค่าระยะ Check-In/Check-Out:</label>
                    <div>
                      <label class="kt-radio kt-radio--bold kt-radio--brand" style="margin-right: 30px;">
                        <input type="radio" v-model="useSettingCheckinRange" :value="true" :disabled="!canEdit" /> กำหนดตามตั้งค่าพื้นฐาน
                        <span></span>
                      </label>
                      <label class="kt-radio kt-radio--bold kt-radio--brand">
                        <input type="radio" v-model="useSettingCheckinRange" :value="false" :disabled="!canEdit" /> กำหนดเอง
                        <span></span>
                      </label>
                      <button v-if="!useSettingCheckinRange" type="button" class="btn btn-sm btn-clean btn-icon"
                        @click="resetCheckinRange" :disabled="!canEdit" title="ใช้ค่า default">
                        <i class="la la-times"></i>
                      </button>
                    </div>
                    <!-- Issue 2: defensive UI — Master.CheckInRange = NULL but useSetting=true -->
                    <div v-if="useSettingCheckinRange && apiLoadedCheckInRange === null" class="alert alert-warning mt-2" style="max-width: 500px;">
                      <i class="la la-exclamation-triangle"></i> ให้ไป apply ค่าที่หน้า ตั้งค่าพื้นฐาน
                    </div>
                    <div v-if="!useSettingCheckinRange" class="mt-2" style="max-width: 300px;">
                      <label class="label-required">ระยะ (เมตร):</label>
                      <input type="number" min="1" max="10000" v-model.number="customCheckInRange"
                        :disabled="!canEdit" class="form-control" placeholder="ระบุระยะ (เมตร)" name="customCheckInRange"
                        @input="checkCustomCheckInRangeMax" @change="checkCustomCheckInRangeMax" />
                      <span v-if="customCheckInRangeMaxError" class="text-danger small">{{ customCheckInRangeMaxError }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- End: CR-PM-2026 Req 2 -->

              <!-- Begin:Map element -->
              <div class="row">
                  <div class="col-xl-12">
                      <div class="form-group">
                          <label>ตำแหน่งที่ตั้ง:</label>
                          <div v-if="eShLat===null">
                              <button :disabled="!canEdit"
                                      type="button"
                                      class="btn m-btn--pill btn-info btn-block col-xl-2"
                                      @click="getMap">
                                  ระบุข้อมูลตำแหน่งที่ตั้ง
                              </button>
                              <!-- ไม่มีข้อมูลตำแหน่งที่ตั้ง -->
                          </div>
                          <div v-else>
                              <GmapMap :center="{lat:eShLat, lng: eShLng}"
                                       :zoom="15"
                                       :clickable="true"
                                       @click="updateCoordinates"
                                       style="width: 500px; height: 300px">
                                  <gmap-marker :key="index"
                                               v-for="(m, index) in eShmarkers"
                                               :position="m.position"
                                               :draggable="true"
                                               @drag="updateCoordinates"
                                               :clickable="true"
                                               @click="updateCoordinates"></gmap-marker>
                              </GmapMap>
                              <br>
                              <div>
                                  <button :disabled="!canEdit" type="button"
                                          class="btn btn-sm btn-secondary"
                                          @click="openMap()">
                                      <i class="far fa-map"></i> Open GoogleMaps
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- End:Map element -->
              <!-- Begin:Picture element -->
              <div class="row">
                  <div class="col-xl-12">
                      <div class="form-group">
                          <label>
                              รูปภาพ:<span class="text-sm text-danger"
                                           style="font-size:small">
                                  (เลือกได้เฉพาะสกุลไฟล์ JPG,JPEG,PNG ขนาดไม่เกิน
                                  10Mb.)
                              </span>
                          </label>
                          <button type="button" :disabled="!canEdit"
                                  class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-2"
                                  @click="uploadFile">
                              <i class="flaticon-upload-1"></i>รูป
                          </button>
                          <div class="row" id="container-img">
                              <div v-for="image in FileUpload"
                                   :key="image.pictureId"
                                   v-if="image.isLoaded"
                                   class="col-md-4 m--margin-top-20 loader loader-secondary bg-overlay img-wrap"
                                   :id="image.pictureId">
                                  <img :src="image.urlImg"
                                       class="img-plant -avatar js-avatar-me img-thumbnail card-img-top"
                                       @error="handleImageError(image)"
                                       @load="handleImageLoad(image)" />
                                  <a href="javascript:;"
                                     style="position:absolute;top:10px;right:20px;"
                                     class="btn m-btn--pill btn-danger m-btn btm-remove-img-plant close"
                                     @click="removeImage(image.pictureId)">
                                      <span class="m--font-inverse-danger la la-trash"></span>
                                  </a>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <!-- End:Picture element -->

              <!-- Begin:InActiveStatus element -->
              <span v-if="eshIfChk == 'STATUS_SHOP_INACTIVE_STOP'" class="text-sm text-danger" style="font-size:small">*ปิดกิจการถาวร และคุณไม่ได้รับอนุญาตให้เปลี่ยนสถานะร้านที่ปิดกิจการถาวร</span>
              <span v-if="eshIfChk == 'STATUS_SHOP_INACTIVE_DUPLICATE'" class="text-sm text-danger" style="font-size:small">*ร้านค้าซ้ำในระบบ</span>
              <div class="row" v-if="(eshIfChk != 'STATUS_SHOP_INACTIVE_STOP' || $root.canShow('super_admin')) && eshIfChk != 'STATUS_SHOP_INACTIVE_DUPLICATE'">
                  <div class="col-xl-2">
                      <div class="form-group">
                          <label>สถานะ:</label>
                          <div class="form-check">
                              <label class="form-check-label kt-checkbox">
                                  <input :disabled="!canEdit"
                                         id="eShInActiveStatus"
                                         name="eShInActiveStatus"
                                         v-model="eShInActiveStatus"
                                         type="checkbox"
                                         class="form-check-input"
                                         @click="chkStatus" />
                                  เปิดใช้งาน
                                  <span></span>
                              </label>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-12">
                      <div v-if="eShInActiveStatus" class="form-group">
                          <label>เหตุผล:</label>
                          <div class="form-check" v-for="data in eShActive">
                              <label class="form-check-label kt-checkbox">
                                  <input id="statusCode"
                                         name="statusCode"
                                         v-model="eShStatus"
                                         :value="data.statusCode"
                                         type="radio"
                                         class="form-check-input" />
                                  {{data.statusName}}
                                  <span></span>
                              </label>
                              <br>
                          </div>
                      </div>
                      <div v-if="!eShInActiveStatus" class="form-group">
                          <label>เหตุผล:</label>
                          <div class="form-check" v-for="data in eShInActive">
                              <label class="form-check-label kt-checkbox">
                                  <input id="statusCode"
                                         name="statusCode"
                                         :value="data.statusCode"
                                         v-model="InActiveStatus"
                                         type="radio"
                                         class="form-check-input" />
                                  {{data.statusName}}
                                  <span></span>
                              </label>
                              <br>
                          </div>
                      </div>
                  </div>

                  <div v-if="this.$root.canShow([''])" class="col-xl-2">
                      <div class="form-group">
                          <label>[PM] ปลด validate การตรวจสอบหน้าข้อมูลร้านค้า</label>
                          <div class="form-check">
                              <label class="form-check-label kt-checkbox">
                                  <input :disabled="!canEdit"
                                         id="eShIgnoreBarcodeValidation"
                                         name="eShIgnoreBarcodeValidation"
                                         v-model="eShIgnoreBarcodeValidation"
                                         type="checkbox"
                                         class="form-check-input" />
                                  เปิดใช้งาน
                                  <span></span>
                              </label>
                          </div>
                      </div>
                  </div>

                  <div v-if="this.$root.canShow([''])" class="col-xl-12">
                  <div class="form-group">
                    <label>[PM] ตั้งค่าใช้ PM (รูปแบบพิเศษ)</label>
                    <div class="form-check">
                      <label class="form-check-label kt-checkbox">
                        <input
                          id="eShIsSpecialPM"
                          name="eShIsSpecialPM"
                          v-model="eShIsSpecialPM"
                          type="checkbox"
                          class="form-check-input"
                        />
                        เปิดใช้งาน PM (รูปแบบพิเศษ)
                        <span></span>
                      </label>
                    </div>
                  </div>
                  </div>
                  
              </div>
              <!-- End:InActiveStatus element -->
          </div>
      </div>
      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
        <button v-if="canEdit" type="submit" class="btn btn-primary">
          <i class="la la-save"></i> บันทึกข้อมูล
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";
import plupload from "plupload";
import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCeGao-PkONmiyVksl46W_OUHt854bcrqE",
    libraries: "places"

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
});

export default {
  components: {
    select2
  },
  data: function() {
    var self = this;

    return {
      canEdit: true,
      eShCustomerCode: null,
      eShCustomerName: null,
      eShName2: null,
      eShShopType: null,
      eShShopPMType : null,
      eShShopGroup: null,
      eShAddress: null,
      eShProvinceId: null,
      eShAmphurId: null,
      eShTumbolId: null,
      eShSubAgent: null,
      eShEmail: null,
      eShContactFullName: null,
      eShContactAgentName: null,
      eShContactAgentLName: null,
      eShEmp: null,
      eShTel: null,
      // CR-PM-2026 Req 2 — Radius config
      useSettingCheckinRange: true,
      customCheckInRange: null,
      customCheckInRangeMaxError: null,
      apiLoadedCheckInRange: undefined, // Issue 2: defensive — track fetched value to detect NULL master case (undefined = not loaded yet)
      eShLat: null,
      eShLng: null,
      eShInActiveStatus: null,
      eShIgnoreBarcodeValidation: null,
      eShIsSpecialPM: false,
      eShAgentCode: null,
      eShmarkers: [],
      FileUpload: [],


      eShStatus:"STATUS_SHOP_ACTIVE_NEW",
      InActiveStatus: "STATUS_SHOP_INACTIVE_CLOSE",
      eShActive:[],
      eShInActive:[],
      eshIfChk:null,
      eShEmpOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Employee/Select2Employee",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopPMTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Variables/Select2MasterShopTypePM",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      eShShopTypeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShShopGroupOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopGroup",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShAmphurIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.eShProvinceId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShTumbolIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchTumbol",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              ampherId: self.eShAmphurId,
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      eShAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              department: [],
              province_id: [],
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    // CR-PM-2026 Req 2 — reset radius to default
    resetCheckinRange() {
      this.useSettingCheckinRange = true;
      this.customCheckInRange = null;
      this.customCheckInRangeMaxError = null;
    },
    // CR-PM-2026 Issue 19 — enforce max 10,000 m on radius input
    checkCustomCheckInRangeMax(e) {
      const raw = e.target.value;
      const val = Number(raw);
      if (raw !== "" && !isNaN(val) && val > 10000) {
        this.customCheckInRangeMaxError = "ไม่สามารถกำหนดระยะทางเกิน 10,000 เมตร ได้";
        // Clamp value back to 10000 (block typing beyond)
        this.customCheckInRange = 10000;
        this.$nextTick(() => { if (e.target) e.target.value = 10000; });
      } else {
        this.customCheckInRangeMaxError = null;
      }
    },
      handleImageError(image) {
          image.isLoaded = false;
          // console.error("รูปภาพโหลดไม่สำเร็จ:", image.fileName);
      },
      handleImageLoad(image) {
          image.isLoaded = true;
          // console.log("รูปภาพโหลดสำเร็จ:", image.fileName);
      },
      removeImage(pictureId) {
          Swal.fire({
              title: "ยืนยันคำสั่ง",
              text: "คุณต้องการลบรูปภาพนี้หรือไม่",
              confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
              confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
              showCancelButton: true,
              cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
              cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
          }).then((result) => {
              if (result.value) {
                  this.FileUpload = this.FileUpload.filter(
                      (img) => img.pictureId !== pictureId
                  );
                  Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
              }
          });
      },
      uploadFile() {
          const input = document.createElement("input");
          input.type = "file";
          input.accept = "image/jpeg,image/png,image/jpg";
          input.click();

          input.addEventListener("change", (event) => {
              const files = event.target.files;
              Array.from(files).forEach((file) => {
                  if (
                      ["image/jpeg", "image/jpg", "image/png"].includes(file.type) &&
                      file.size <= 10 * 1024 * 1024
                  ) {
                      const reader = new FileReader();
                      reader.onload = (e) => {
                          const newImage = {
                              pictureId: Date.now().toString(),
                              fileName: file.name,
                              urlImg: e.target.result,
                              fileDataContext: file,
                              isNew: true,
                              isLoaded: true,
                          };
                          this.FileUpload.push(newImage);
                      };
                      reader.readAsDataURL(file);
                  } else {
                      alert(
                          "กรุณาเลือกไฟล์ภาพที่ถูกต้อง (JPG, JPEG, PNG ขนาดไม่เกิน 10MB)"
                      );
                  }
              });
          });
      },
      async onSubmit(e) {
      //onSubmit: function(e) {
      let router = this.$router;
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

        let uploadedFiles = [];
        let isUploadFile = false;

          for (let file of this.FileUpload) {

              if (file.isNew && file.fileDataContext) {
                  //alert('new file & datacontext');
                try {
                    isUploadFile = true;
                    const formData = new FormData();
                    formData.append("File", file.fileDataContext);
                    formData.append("IsMaster", true);
                    formData.append("FolderName", "MasterShop");

                    const uploadResponse = await axios.post("/Api/File/FileUpload", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    //console.log('uploadResponse', uploadResponse)

                    uploadedFiles.push({
                        contentType: "-",
                        downloadUrl: uploadResponse.data.fileUrl,
                        fileInfoId: uploadResponse.data.fileInfoId,
                        fileName: uploadResponse.data.fileInfoId,
                        gridFsId: uploadResponse.data.gridFsId,
                        sysName: "-",
                    });
                } catch (error) {
                    console.error("เกิดข้อผิดพลาดในการอัปโหลดไฟล์:", error);
                }
              } else if (!file.isNew) {
                  //alert('old file : ' + file.fileInfoId);

                uploadedFiles.push(file);
            }
        }

          //alert("uploadedFiles.length : " + uploadedFiles.length);

          //const picturesData = isUploadFile && uploadedFiles.length > 0 ? uploadedFiles : [];

          const picturesData = uploadedFiles.length > 0 ? uploadedFiles : []; // Case : Remove image.

 
      axios
          .put("/Api/Shop", {
          ShopId: self.$route.params.id,
          CustomerCode: self.eShCustomerCode,
          Latitude: self.eShLat,
          Longitude: self.eShLng,
          ContactAgentName: self.eShContactAgentName,
          ContactAgentLastName: self.eShContactAgentLName,
          EmployeeId: self.eShEmp,
          InActiveStatus: !self.eShInActiveStatus,
          ShopPictures: picturesData, //self.eShImgUpload,
          SubAgent: self.eShSubAgent,
          CustomerName: self.eShCustomerName,
          Name2 : self.eShName2,
          ShopTypeId: self.eShShopType,
          ShopGroupId: self.eShShopGroup,
          ShopPMType : self.eShShopPMType,
          Address: self.eShAddress,
          ProvinceId: self.eShProvinceId,
          AmphurId: self.eShAmphurId,
          TumbolId: self.eShTumbolId,
          ContactFullName: self.eShContactFullName,
          Email: self.eShEmail,
          Tel: self.eShTel,
          AgentCode: self.eShAgentCode,
          Reason : self.eShInActiveStatus == true ? self.eShStatus : self.InActiveStatus,
          IgnoreBarcodeValidation : self.eShIgnoreBarcodeValidation,
          IsSpecialPM : self.eShIsSpecialPM,
          // CR-PM-2026 Req 2
          UseSettingCheckinRange: self.useSettingCheckinRange,
          CheckInRange: self.useSettingCheckinRange ? null : self.customCheckInRange
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    getMap: function() {
      //get current lat,lon by IP
      navigator.geolocation.getCurrentPosition(position => {
        this.eShLat = position.coords.latitude;
        this.eShLng = position.coords.longitude;
        this.eShmarkers = [
          {
            position: { lat: this.eShLat, lng: this.eShLng },
            animation: google.maps.Animation.DROP
          }
        ];
      });
    },
    //get current lat,lng (dragable)
    updateCoordinates(location) {
      this.eShLat = location.latLng.lat();
      this.eShLng = location.latLng.lng();
      map: this.map;
      this.eShmarkers = [{ position: { lat: this.eShLat, lng: this.eShLng } }];
    },
    openMap(){
      var self = this;
      window.open("https://www.google.com/maps/search/?api=1&query="+self.eShLat+","+self.eShLng, "_blank");
    },
    getStatusShop()
    {
      var self = this;
      axios
      .get("/Api/Shop/StatusShop")
      .then(function(response) {
        if (response.status == 200) {
          self.eShActive = response.data.filter(o => o.statusGroup == "STATUS_SHOP_ACTIVE");
          self.eShInActive = response.data.filter(o => o.statusGroup == "STATUS_SHOP_INACTIVE");
        }
      })
    },
    chkStatus()
    {
      if(this.eshIfChk == "STATUS_SHOP_INACTIVE_CLOSE")
      {
        this.eShActive = this.eShActive.filter(o => o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_CLOSE");
      }
      else if(this.eshIfChk== "STATUS_SHOP_INACTIVE_CHANGE")
      {
        this.eShActive = this.eShActive.filter(o => o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_COMEBACK");
      }
      else if (this.eshIfChk == "STATUS_SHOP_INACTIVE_BEER")
      {
        this.eShActive = this.eShActive.filter(o => o.statusCode == "STATUS_SHOP_ACTIVE_NEW" || o.statusCode == "STATUS_SHOP_ACTIVE_BEER");
      }
      else
      {
        this.eShActive = this.eShActive;
      }
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
      let user = await this.$root.getUser();


    self.getStatusShop();
    //self.initPlUploader();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่..."
    });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        eShCustomerName: "required",
        eShShopType: "required",
        eShShopPMType : "required",
        eShShopGroup: "required",
        // eShEmail: {
        //   emailNullable: true
        // },
        eShAddress: "required",
        eShProvinceId: "required",
        eShAmphurId: "required",
        eShTumbolId: "required",
        eShTel: "required",
        eShAgentCode: "required",
        eShName2: "required",
        // CR-PM-2026 Issue 14: required เฉพาะกรณี "กำหนดเอง" (useSettingCheckinRange=false)
        customCheckInRange: {
          required: function() { return !self.useSettingCheckinRange; }
        }
      },
      messages: {
        eShCustomerName: "กรุณากรอกชื่อร้านค้า",
        eShShopType: "กรุณาเลือกประเภทร้านค้า",
        eShShopGroup: "กรุณาเลือกสถานะประเภทร้านค้า",
        // eShEmail: {
        //   emailNullable: "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง"
        // },
        eShAddress: "กรุณากรอกที่อยู่",
        eShProvinceId: "กรุณาเลือกประเภทจังหวัด",
        eShAmphurId: "กรุณาเลือกประเภทอำเภอ",
        eShTumbolId: "กรุณาเลือกประเภทตำบล",
        eShTel: "กรุณากรอกเบอร์โทร",
        eShAgentCode: "กรุณาเลือกผู้ดูแลร้านค้า",
        eShName2: "กรุณากรอกชื่อร้านค้า 2",
        eShShopPMType : "ประเภทการล้างเครื่อง",
        customCheckInRange: "กรุณาระบุระยะ (เมตร)"
      }
    });

    axios
      .get("/Api/Shop/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.canEdit = response.data.canEdit;
          self.eShCustomerCode = response.data.custCode;
          self.eShCustomerName = response.data.customerName;
          self.eShName2 = response.data.name2;
          self.eShAddress = response.data.address;
          self.eShEmail = response.data.email;
          self.eShTel = response.data.tel;
          self.eShContactFullName = response.data.fullName;
          self.eShContactAgentName = response.data.contactAgentName;
          self.eShContactAgentLName = response.data.contactAgentLastName;
          self.eShSubAgent = response.data.subAgent;
          self.eShInActiveStatus = !response.data.inActiveStatus;
          self.eShStatus = !response.data.inActiveStatus  ? response.data.reason : "STATUS_SHOP_ACTIVE_NEW";
          self.InActiveStatus = response.data.inActiveStatus ? response.data.reason : "STATUS_SHOP_INACTIVE_CLOSE";
          self.eshIfChk = response.data.inActiveStatus ? response.data.reason : "STATUS_SHOP_INACTIVE_CLOSE";
          self.eShIgnoreBarcodeValidation = response.data.ignoreBarcodeValidation;
          self.eShIsSpecialPM = (response.data.isSpecialPM != null) ? response.data.isSpecialPM : false;

          self.eShShopPMType = response.data.shopPMType; 
            if (response.data.shopPMType) {
            self.$refs.eShShopPMTypeSelect2.setSelectedData({
              id: response.data.shopPMType,
              text: response.data.shopPMTypeName
            });
            } 

          
          if(self.$root.canShow('super_admin')){
            if (response.data.employeeId) {
              self.$refs.eShEmpSelect2.setSelectedData({
                id: response.data.employeeId,
                text:
                  "[" +
                  response.data.employeeNo +
                  "] " +
                  response.data.employeeName +
                  " " +
                  response.data.employeeLastName
              });
            }
          }

          if (response.data.shopTypeId) {
            self.$refs.eShShopTypeSelect2.setSelectedData({
              id: response.data.shopTypeId,
              text: response.data.shopTypeName
            });
          }

          if (response.data.shopGroupId) {
            self.$refs.eShShopGroupSelect2.setSelectedData({
              id: response.data.shopGroupId.toString(),
              text: response.data.shopGroupName
            });
          }

          if (response.data.provinceId) {
            self.$refs.eShProvinceIdSelect2.setSelectedData({
              id: response.data.provinceId,
              text: response.data.provinceName
            });
          }

          if (response.data.ampherId) {
            self.$refs.eShAmphurIdSelect2.setSelectedData({
              id: response.data.ampherId,
              text: response.data.ampherName
            });
          }

          if (response.data.tambolId) {
            self.$refs.eShTumbolIdSelect2.setSelectedData({
              id: response.data.tambolId,
              text: response.data.tambolName
            });
          }

          if (response.data.agentCode) {
            self.$refs.eShAgentCodeSelect2.setSelectedData({
              id: response.data.agentCode,
              text: response.data.agentName
            });
          }
          // CR-PM-2026 Req 2
          self.useSettingCheckinRange = (response.data.useSettingCheckinRange != null) ? response.data.useSettingCheckinRange : true;
          self.customCheckInRange = (!self.useSettingCheckinRange) ? response.data.checkInRange : null;
          // Issue 2: capture fetched value to detect NULL master case
          self.apiLoadedCheckInRange = (response.data.checkInRange != null) ? response.data.checkInRange : null;

          //Set lat lng
          response.data.latitude === null
            ? (self.eShLat = null)
            : (self.eShLat = parseFloat(response.data.latitude));
          response.data.longitude === null
            ? (self.eShLng = null)
            : (self.eShLng = parseFloat(response.data.longitude));

          self.eShmarkers = [
            { position: { lat: self.eShLat, lng: self.eShLng } }
            ];

            //alert(response.data.pictures[0].pictureId);

            self.FileUpload = response.data.pictures.map((element) => ({
                pictureId: element.pictureId,
                fileName: element.fileName,
                fileInfoId: element.fileInfoId,
                downloadUrl: element.downloadUrl,
                urlImg: element.urlImg,
                gridFsId: element.gridFsId,
                sysName: element.sysName,
                isNew: false,
                isLoaded: true,
            }));
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลคลังสินค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลคลังสินค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  }
};
</script>

<style lang="scss">
#myProgress {
  width: 100%;
  background-color: #ddd;
}

.myBar {
  width: 10%;
  height: 30px;
  background-color: #4caf50;
  text-align: center;
  line-height: 30px;
  color: white;
}

.btm-reload-img-shop {
  position: absolute;
  top: 5px;
  right: 20px;
}
.btm-delete-img-shop {
  position: absolute;
  top: 5px;
  right: 70px;
}
.btm-remove-img-shop {
  position: absolute;
  top: 5px;
  right: 20px;
}

.select2,
.select2-dropdown {
  font-size: 1rem;
}

@media (max-width: 425px) {
  .m-body .m-content {
    padding: 20px 5px;
  }
}

@media (max-width: 1200px) {
  .m-wizard.m-wizard--2 {
    margin-top: 8rem !important;
  }

  #activity_wizard .m-wizard__form .m-form .m-portlet__body {
    padding: 2.2rem 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// App/Components/Master/Shop/EditShop.vue